// src/features/auth/find-id/services/findIdService.ts

import {
  AUTH_ENDPOINTS,
} from '../../../../api';

import api from '../../../../api/axios';

import type {
  ApiResponse,
} from '../../../../shared/types/api.types';


export interface FindIdRequest {
  phoneNumber: string;
  verificationToken: string;
}


export interface FindIdResponse {
  userId: string;
}


export const findId =
  async (
    request: FindIdRequest,
  ): Promise<FindIdResponse> => {
    const response =
      await api.post<
        ApiResponse<FindIdResponse>
      >(
        AUTH_ENDPOINTS
          .FIND_ID,
        request,
      );

    const data =
      response.data.data;

    if (
      !data?.userId
    ) {
      throw new Error(
        '아이디 조회 결과가 없습니다.',
      );
    }

    return data;
  };